/**
 * Temporary “online sales down” slide-in notice.
 * Shows on homepage, and when shoppers add to cart / open the cart.
 */
(function () {
  'use strict';

  var el = document.getElementById('SalesDownNotice');
  if (!el) return;

  var DISMISS_KEY = 'skyhigh_sales_down_dismissed';
  var hideTimer = null;
  var AUTO_HIDE_MS = 14000;

  function isDismissed() {
    try {
      return sessionStorage.getItem(DISMISS_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function setDismissed() {
    try {
      sessionStorage.setItem(DISMISS_KEY, '1');
    } catch (e) {}
  }

  function headerOffset() {
    // Place banner just under sticky header / utility bar so nav stays clickable
    var selectors = [
      '.section-header',
      '#shopify-section-header',
      'sticky-header',
      '.header-wrapper',
      '#shopify-section-announcement-bar',
      '.shopify-section-group-header-group',
    ];
    var bottom = 0;
    for (var i = 0; i < selectors.length; i++) {
      var nodes = document.querySelectorAll(selectors[i]);
      for (var j = 0; j < nodes.length; j++) {
        var r = nodes[j].getBoundingClientRect();
        if (r.height > 0 && r.bottom > bottom) bottom = r.bottom;
      }
    }
    // Fallback if header not measured yet
    if (bottom < 48) bottom = 72;
    return Math.ceil(bottom + 8);
  }

  function placeBelowHeader() {
    try {
      el.style.setProperty('--sales-down-offset', headerOffset() + 'px');
    } catch (e) {}
  }

  function show(reason) {
    if (isDismissed()) return;
    placeBelowHeader();
    el.hidden = false;
    el.setAttribute('aria-hidden', 'false');
    // force reflow for transition
    void el.offsetWidth;
    el.classList.add('sales-down-notice--in');
    el.dataset.reason = reason || '';

    if (hideTimer) clearTimeout(hideTimer);
    // Stay longer on cart-triggered shows
    var ms = reason === 'cart' ? 18000 : AUTO_HIDE_MS;
    hideTimer = setTimeout(function () {
      hide(false);
    }, ms);
  }

  window.addEventListener(
    'resize',
    function () {
      if (el.classList.contains('sales-down-notice--in')) placeBelowHeader();
    },
    { passive: true }
  );
  window.addEventListener(
    'scroll',
    function () {
      if (el.classList.contains('sales-down-notice--in')) placeBelowHeader();
    },
    { passive: true }
  );

  function hide(permanent) {
    el.classList.remove('sales-down-notice--in');
    el.setAttribute('aria-hidden', 'true');
    if (permanent) setDismissed();
    setTimeout(function () {
      if (!el.classList.contains('sales-down-notice--in')) {
        el.hidden = true;
      }
    }, 400);
    if (hideTimer) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }
  }

  var closeBtn = el.querySelector('.sales-down-notice__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      hide(true);
    });
  }

  // Homepage: slide in after short delay
  var isHome =
    document.body.classList.contains('template-index') ||
    window.location.pathname === '/' ||
    window.location.pathname === '';

  if (isHome) {
    setTimeout(function () {
      show('home');
    }, 900);
  }

  // Dawn product form ATC success → cart drawer/notification
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;
      // Show optimistically; cart apps still process the add
      setTimeout(function () {
        show('cart');
      }, 350);
    },
    true
  );

  // Shopify theme events (when published by cart / product-form)
  document.addEventListener('cart:updated', function () {
    show('cart');
  });
  document.addEventListener('cart:refresh', function () {
    show('cart');
  });

  // Cart icon / bubble clicks
  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (
        t.closest('a[href="/cart"]') ||
        t.closest('#cart-icon-bubble') ||
        t.closest('.header__icon--cart') ||
        t.closest('[id*="cart-icon"]') ||
        t.closest('a[href*="/cart"]')
      ) {
        setTimeout(function () {
          show('cart');
        }, 200);
      }
    },
    true
  );

  // Rebuy Smart Cart open
  function watchRebuy() {
    var cart = document.getElementById('rebuy-cart');
    if (!cart || !window.MutationObserver) return;
    var mo = new MutationObserver(function () {
      if (cart.classList.contains('is-visible')) {
        show('cart');
      }
    });
    mo.observe(cart, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchRebuy);
  } else {
    watchRebuy();
  }
  // Late Rebuy mount
  setTimeout(watchRebuy, 1500);
  setTimeout(watchRebuy, 4000);
})();
